const getReturnReason = (returnReasons, inputNames, values) => {
  return returnReasons?.find((reason) => reason.key === values[inputNames.reason])?.value;
};
export {
  getReturnReason
};
//# sourceMappingURL=get-return-reason.js.map
